const httpResponseCodes = {
  'API_LIMIT_EXCEEDED': 429,
};

export default httpResponseCodes;
